import style from './sidebar-icon.module.less';

export const SidebarCollapsedIcon = () => (
  <svg className={style['sidebar-icon']} fill='none' height='20' viewBox='0 0 20 20' width='20' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.3766 7.01125V12.9888L13.3733 10L10.3766 7.01125ZM4.16663 15.8333H6.66663V4.16667H4.16663V15.8333ZM7.91663 15.8333H15.8333V4.16667H7.91663V15.8333ZM2.91663 17.0833V2.91667H17.0833V17.0833H2.91663Z'
      fill='currentColor'
    />
  </svg>
);
